// removed by extract-text-webpack-plugin
module.exports = {"lds-ring":"src-components-SearchInput-SearchLoader----SearchLoader-module---lds-ring---jTXJ6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchInput/SearchLoader/SearchLoader.module.scss
// module id = 202
// module chunks = 82273022296103 114276838955818 193433272603103